import { render, staticRenderFns } from "./compareBar2.vue?vue&type=template&id=5cc4d922&scoped=true&"
import script from "./compareBar2.vue?vue&type=script&lang=js&"
export * from "./compareBar2.vue?vue&type=script&lang=js&"
import style0 from "./compareBar2.vue?vue&type=style&index=0&id=5cc4d922&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc4d922",
  null
  
)

export default component.exports